import Workshops from "../data/workshops.json";
import Technical from "../data/technical.json";
import NonTechnical from "../data/non_technical.json";

const Carousel = (key) => {
  const range = [
    "w1",
    "w2",
    "w3",
    "t1",
    "t2",
    "t3",
    "t4",
    "t5",
    "t6",
    "t7",
    "t8",
    "n1",
    "n2",
    "n3",
    "n4",
    "n5",
  ];
  var arr = [];
  while (arr.length < 4) {
    var r = Math.floor(Math.random() * 15);
    if (arr.indexOf(range[r]) === -1 && range[r] !== key.id) arr.push(range[r]);
  }
  console.log(arr);

  return (
    <div className="w-4/5 mx-auto py-4 my-6">
      <h4 className="text-3xl font-bold my-8 md:text-center sm:text-2xl">
        Explore More Events
      </h4>
      <div className="mb-10 flex flex-wrap">
        {arr.map((a) => {
          if (a.charAt(0) === "w")
            return (
              <a
                className="w-1/4 overflow-hidden hover:brightness-150 smm:w-full smm:mb-8 md:w-1/2"
                href={`/${a}`}
              >
                <img
                  className=" transition ease-in-out hover:scale-110"
                  alt="Poster"
                  src={Workshops[a].poster_link}
                />
              </a>
            );
          else if (a.charAt(0) === "t")
            return (
              <a
                className="w-1/4 overflow-hidden hover:brightness-150 smm:w-full smm:mb-8 md:w-1/2"
                href={`/${a}`}
              >
                <img
                  className=" transition ease-in-out hover:scale-110"
                  alt="Poster"
                  src={Technical[a].poster_link}
                />
              </a>
            );
          else
            return (
              <a
                className="w-1/4 overflow-hidden hover:brightness-150 smm:w-full smm:mb-8 md:w-1/2"
                href={`/${a}`}
              >
                <img
                  className=" transition ease-in-out hover:scale-110"
                  alt="Poster"
                  src={NonTechnical[a].poster_link}
                />
              </a>
            );
        })}
      </div>
    </div>
  );
};
export default Carousel;
